<template>
  <a :href="webOrderUrl" target="_blank" class="text-blue-500 underline">
    {{ params.value }}
  </a>
</template>

<script>
export default {
  name: "ShopifyOrderLink",
  data() {
    return {
      webOrderCartsBB: [23, 24],
      webOrderCartsFGT: [22, 32],
      webOrderCartsPT: [31],
    };
  },
  computed: {
    webOrderUrl() {
      if (this.webOrderCartsBB.includes(parseInt(this.params.data.CartID)))
        return process.env.VUE_APP_WEB_ORDER_BB + this.params.value;

      if (this.webOrderCartsFGT.includes(parseInt(this.params.data.CartID)))
        return process.env.VUE_APP_WEB_ORDER_FGT + this.params.value;

      if (this.webOrderCartsPT.includes(parseInt(this.params.data.CartID)))
        return process.env.VUE_APP_WEB_ORDER_PT + this.params.value;

      return null;
    },
  },
};
</script>
